import { configureStore } from '@reduxjs/toolkit';
import dressesReducer from './slices/dressesSlice';
import cartReducer from './slices/cartSlice';
import filtersReducer from './slices/filtersSlice';
import authReducer from './slices/authSlice';
import toastReducer from './slices/toastSlice';
import siteAlertReducer from './slices/siteAlertSlice';

export const store = configureStore({
  reducer: {
    dresses: dressesReducer,
    cart: cartReducer,
    filters: filtersReducer,
    auth: authReducer,
    toast: toastReducer,
    siteAlert: siteAlertReducer,
  },
});

export default store;
